/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellLogic/ChallengeAuthorities/SolveGameDailyFreeCellAuthority',[
    'SolitaireShared/FreeCellLogic/IDailyFreeCellAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority'
], function (IDailyFreeCellAuthority, IDailyAuthority) {
    "use strict";

    var SolveGameDailyFreeCellAuthority = function (param) {
        this.initSolveGameDailyFreeCellAuthority(param);
    };

    SolveGameDailyFreeCellAuthority.constructor = SolveGameDailyFreeCellAuthority;
    SolveGameDailyFreeCellAuthority.prototype = Object.create(IDailyFreeCellAuthority.prototype);

    SolveGameDailyFreeCellAuthority.prototype.initSolveGameDailyFreeCellAuthority = function (param) {
        IDailyFreeCellAuthority.call(this, param);

        this.ChallengeType = IDailyAuthority.ChallengeType.SolveGame;
    };

   return SolveGameDailyFreeCellAuthority;

});
